import { render } from "./EmailTemplateRenderer.vue?vue&type=template&id=c50898f2&scoped=true&ts=true"
import script from "./EmailTemplateRenderer.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateRenderer.vue?vue&type=script&lang=ts"

import "./EmailTemplateRenderer.vue?vue&type=style&index=0&id=c50898f2&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50898f2"]])

export default __exports__